<template>
    <div class="modal fade reg-sucess" :class="{ 'show' : show}">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click.prevent="closeModal">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M19 5L5 19M5.00001 5L19 19" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </button>
                    <div id='card' class="animated fadeIn">
                        <div id='upper-side'>
                            <svg width="64px" height="64px" viewBox="0 0 1024 1024" fill="#ffffff" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M512 1017.6C233.6 1017.6 7.2 790.4 7.2 512S233.6 6.4 512 6.4s505.6 226.4 505.6 505.6-226.4 505.6-505.6 505.6zM512 54.4C260 54.4 55.2 260 55.2 512s204.8 457.6 457.6 457.6 457.6-204.8 457.6-457.6S764.8 54.4 512 54.4z m-31.2 652s-0.8 0 0 0h-5.6v-0.8H472l-1.6-0.8c-0.8 0-0.8 0-1.6-0.8h-1.6l-0.8-0.8-2.4-0.8-1.6-1.6-202.4-170.4c-4.8-4-8-9.6-8.8-16-0.8-6.4 1.6-12.8 5.6-17.6 4.8-5.6 11.2-8.8 18.4-8.8 5.6 0 11.2 2.4 15.2 5.6l185.6 156.8 296.8-296.8c4.8-4.8 10.4-7.2 16.8-7.2s12.8 2.4 16.8 7.2c4.8 4.8 7.2 10.4 7.2 16.8s-2.4 12.8-7.2 16.8l-312 312-2.4 1.6-0.8 0.8c-0.8 0.8-1.6 0.8-2.4 1.6 0 0.8 0 0.8-0.8 0.8l-0.8 0.8c-0.8 0-2.4 0.8-2.4 0.8-0.8 0-0.8 0-1.6 0.8H480.8z" fill=""></path></g></svg>
                            <h3 id='status' class="mt-10">{{ title }}</h3>
                        </div>
                        <div id='lower-side'>
                            <p id='message'>{{ details }}</p>
                            <router-link :to="{name: 'login'}" id="contBtn">Continue</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "alert-modal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
        type: String, 
        required: true
    },
    details: {
        type: String, 
        required: true
    }
  },
  methods: {
    closeModal(){
        this.$emit("closeModal");
    }
  }
}
</script>
<style scoped>
    .modal{
        background: #cac9c999;
    }
</style>